import React from 'react';
import IconBase from './Icon-base';
export default class TogglerThumbs extends React.Component {
    render() {
        return (
            <IconBase width="36" height="30" viewBox="0 0 36 30" {...this.props}>
                <g id="Canvas_tgt" transform="translate(-330 235)">
                    <g id="Group 2_tgt">
                        <g id="Notes Icon - Inactive_tgt">
                            <use
                                xlinkHref="#path0_fill_tgt"
                                transform="translate(340 -235)"
                                fill="#4F5056"
                            />
                        </g>
                        <g id="Back Button_tgt">
                            <use
                                xlinkHref="#path1_fill_tgt"
                                transform="translate(330 -224)"
                                fill="#4F5056"
                            />
                        </g>
                    </g>
                </g>
                <defs>
                    <path
                        id="path0_fill_tgt"
                        fillRule="evenodd"
                        d="M 0 6L 0.5 6L 6 6L 6 7L 1 7L 1 28.5L 20.5 28.5L 20.5 24.5L 21.5 24.5L 21.5 29L 21.5 29.5L 21 29.5L 0.5 29.5L 0 29.5L 0 29L 0 6.5L 0 6ZM 10.4445 9.23914L 21.5556 9.23914L 21.5556 10.3261L 10.4445 10.3261L 10.4445 9.23914L 10.4445 9.23914ZM 10.4445 14.6739L 21.5556 14.6739L 21.5556 13.587L 10.4445 13.587L 10.4445 14.6739L 10.4445 14.6739ZM 10.4445 19.0217L 21.5556 19.0217L 21.5556 17.9348L 10.4445 17.9348L 10.4445 19.0217L 10.4445 19.0217ZM 26 4.75543L 26 25L 6 25L 6 0L 21.1389 0L 26 4.75543L 26 4.75543ZM 24.8889 5.97826L 19.8889 5.97826L 19.8889 1.08696L 7.1111 1.08696L 7.1111 23.913L 24.8889 23.913L 24.8889 5.97826L 24.8889 5.97826ZM 24.5672 4.89132L 21 1.40164L 21 4.89132L 24.5672 4.89132L 24.5672 4.89132Z"
                    />
                    <path
                        id="path1_fill_tgt"
                        fillRule="evenodd"
                        d="M 7 1.14286L 5.88 0L 0 5.94257L 5.88 12L 7 10.8571L 2.24 5.94257L 7 1.14286Z"
                    />
                </defs>
            </IconBase>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/DocumentViewer/src/SVGIcons/TogglerThumbs.js